import { render, staticRenderFns } from "./practice-error.vue?vue&type=template&id=36779726&scoped=true&"
import script from "./practice-error.vue?vue&type=script&lang=js&"
export * from "./practice-error.vue?vue&type=script&lang=js&"
import style0 from "./practice-error.vue?vue&type=style&index=0&id=36779726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36779726",
  null
  
)

export default component.exports